import styles from './FeatureTile.module.scss';

import React, { FC } from 'react';

import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';
import { Topic } from 'api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'components/TextV2/TextV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { SubjectMedia } from 'components/SubjectMedia/SubjectMedia';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

export type FeatureTileProps = {
  entry?: FlatEntry<Topic>;
};

export const FeatureTile: FC<FeatureTileProps> = ({ entry }) => {
  if (!entry) return null;

  const { title, richBlurb } = entry;

  return (
    <FadeToastUp>
      <div className={styles.featureTile}>
        <div className={styles.textWrapper}>
          <TextV2 className={styles.eyebrow} variant="modern-eyebrow" value={title} />
          <RichBlurb document={richBlurb} className={styles.description} />
        </div>
        <SubjectMedia entry={entry} className={styles.media} playWhenInView loop />
      </div>
    </FadeToastUp>
  );
};

export default FeatureTile;
